export function IconLinkToPeriod () {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M13.8375 7.58816L9.61677 3.17141C9.2661 2.80515 8.66676 3.06467 8.66676 3.58302V5.64663C5.06804 5.72617 2 9.06297 2 12.8832C3.22135 11.0143 5.58605 9.85968 8.66676 10.2197V10.2322V12.4165C8.66676 12.9356 9.2661 13.1951 9.61677 12.8281L13.8375 8.41138C14.0542 8.18395 14.0542 7.81559 13.8375 7.58816Z"
            fill="#1A76E2"/>
    </svg>

  )
}
